(function(){
/* Fan identification form (Amphibious Marine). Markup: sections/fan-id-wizard.liquid. Styles: assets/fanid.css.
endpoint: FormSubmit address that emails each request with photos. */
const CONFIG = {
endpoint: "https://formsubmit.co/bryan@amphibiousmarine.com",
thankYouUrl: (document.getElementById("fanid").dataset.thanks || ""),
subject: "Fan ID request",
storeUrl: "",   // links stay on this store
imgBase: (document.getElementById("fanid").dataset.imgbase || ""),
maxTotalMB: 9.5,
maxPhotoPx: 1600
};
/* ============ DATA FROM THE MULTIWING FAN IDENTIFICATION GUIDE ============ */
const SERIES = {
H:{name:"H Series",dia:[7,29],blades:[2,14],pitch:"25°–50° in 5° steps",root:"Root has four posts on a rectangular base. Smallest fans.",
pitchHow:"H blades have the pitch molded on the blade. 1H, 4H, 6H: concave side of the blade base. 2H: top of the blade root. 3H plastic: convex side of the base. 3H aluminum: convex side of the leading or trailing edge."},
Z:{name:"Z Series",dia:[12.5,49.5],blades:[2,16],pitch:"20°–50°",root:"Round root with notches labeled with pitch angles. Medium fans.",
pitchHow:"Z blades have the pitch angles molded inside the blade root. A pitch pin sits in one of four numbered grooves in each hub socket, and the blade is turned until the chosen angle lines up with the pin. Read the angle that lines up with the pin (it is sometimes pencil-marked). 6Z roots show angles for both rotations, such as L35 and R35. Can't read it? Use the pin helper below."},
W:{name:"W Series",dia:[22,84.25],blades:[2,13],pitch:"15°, 17°, and 20°–50°",root:"Round root with a slot holding a plastic pitch insert. Large fans.",insert:true,
pitchHow:"W blades use a pitch insert in the blade root. Find the extended hash mark. Marks are in 5° groups: on a right-hand fan count from the right, on a left-hand fan count from the left. 8W inserts show both rotations."},
G:{name:"G Series",dia:[48,108],blades:[2,8],pitch:"20°–50°",root:"Round root with a pitch insert. The largest fans.",insert:true,
pitchHow:"G blades use a pitch insert in the blade root. Find the extended hash mark. Marks are in 5° groups: on a right-hand fan count from the right, on a left-hand fan count from the left."},
D:{name:"D Series (8D)",dia:[12,26],blades:[2,4],pitch:"25°, 30°, 35°, 40°",root:"One-piece molded fan on an aluminum boss. 2 or 4 blades.",
pitchHow:"On the 8D the pitch angle is molded at the base of the blade."},
M:{name:"M Series (8M)",dia:[10,20],blades:[2,12],pitch:"30°, 35°, 40°",root:"One-piece molded fan on an aluminum boss. Small fans.",
pitchHow:"On the 8M the pitch angle is molded at the base of the blade, next to the series name."},
U:{name:"Not sure",root:"Send a close-up of the blade root and we'll identify it.",pitchHow:"Look for a molded number near the blade base or inside the root, or a plastic insert with hash marks in the root. Photograph whatever you find."}
};
/* blade widths in inches, where the name is molded, materials */
const BLADES = [
["1H","H",2.58,"Concave side of the blade base","PAG"],
["2H","H",2.58,"Not molded on the blade","PAG, PPG"],
["3H","H",3.36,"Plastic: convex side of the base, on the cone. Aluminum 3HR: concave side of the base; 3HL may not be marked","PAG, PPG, AL"],
["4H","H",2.58,"Concave side of the blade base","PAG"],
["6H","H",2.56,"Concave side of the blade edge, stamped 6H with no L or R","PAG"],
["1Z","Z",4.00,"Concave side of the blade base","PAG, PAGI, PPG"],
["2Z","Z",5.25,"Concave side of the blade base","AL, PAG, PAGI, PPG"],
["3ZL","Z",3.25,"Outside of the root","AL, PAGI"],
["4Z","Z",4.50,"Concave side of the blade base (PAGST: inside the root)","AL, PAG, PAGAS, PAGST, PPG"],
["5Z","Z",5.25,"Concave side of the base. Aluminum 5Z is not marked. PAGST: inside the root","AL, PAG, PAGAS, PAGST, PPG"],
["6Z","Z",5.00,"Concave side of the blade base","PAG"],
["7Z","Z",5.25,"Concave side of the blade base","PAG, PPG"],
["TR7Z","Z",5.25,"Concave side of the blade base","AL, PAG, PPG"],
["TR8Z","Z",5.25,"Concave side of the blade base","AL"],
["1W","W",6.00,"Concave side of the blade base","PAG, PAGI, PAGAS, PPG"],
["2WL","W",7.25,"Concave side of the blade base","PAG, PAGI, PPG"],
["3WL","W",11.00,"Concave side of the blade base","PAG, PPG"],
["5W","W",8.00,"Concave side of the blade base","AL, PAG, PPG"],
["6W","W",8.50,"Concave side of the blade base","AL, PAG, PAGAS, PAGST, PPG"],
["7W","W",8.00,"Concave side of the blade base","PAG, PAGAS, PPG"],
["8W","W",9.00,"Concave side of the blade edge","PAG, PAGAS, PPG"],
["9W","W",10.25,"Concave side of the blade base","AL, PAG, PAGI, PAGAS, PPG"],
["TR11W","W",8.00,"Concave side of the blade base","AL"],
["1GL","G",14.25,"Concave side of the blade base","PAG"],
["10G","G",16.25,"Concave side of the blade base","PAG, PAGI"]
];
const MATERIALS = [
["PAG","Glass-reinforced nylon, gray","#8C9399","-40 to 248",[-40,248]],
["PAG black","Glass-reinforced nylon, black","#1D1F22","-40 to 248",[-40,248]],
["PAG natural","Glass-reinforced nylon, natural","#E6DDC6","-40 to 248",[-40,248]],
["PAGI","Glass-reinforced nylon, industrial","","-40 to 248",[-40,248]],
["PAGST","Super Tuff nylon","","-40 to 248",[-40,248]],
["PAGAS","Anti-static nylon","","-40 to 248",[-40,248]],
["PPG","Glass-reinforced polypropylene","","14 to 194",[14,194]],
["AL","Aluminum (no material dial)","linear-gradient(135deg,#d9dde1,#9aa3ab)","-76 to 473",[-76,473]],
["Unknown","Can't find or read the dial","","",null]
];
const BUSHINGS = {
G:"Bore 3/8–1 in. Small, light fans (H06–H10).", JA:"Bore 1/2–1 1/4 in.", H:"Bore 3/8–1 1/2 in.", SH:"Bore 1/2–1 5/8 in.",
P1:"Bore 1/2–1 3/4 in. External key, suits high HP and extreme temperature.", SD:"Bore 1/2–1 15/16 in.", SK:"Bore 1/2–2 1/2 in. 90 mm boss only.",
SF:"Bore 1/2–2 15/16 in. 90 mm boss or G-series boss.", Q:"Bore 3/4–2 11/16 in. External key.", R:"Bore 1 1/8–3 3/4 in. External key.", "Unreadable":"Measure the shaft and keyway below."
};
/* Z series pitch from pin groove (Multiwing Z Series Pitch Setting Instructions, Rev 10).
A = 1Z, 2Z, 4Z, 7Z, TR7Z, TR8Z, EMax   B = 5Z, PMax6   C = 6Z.  0 = not offered. */
const ZTAB = {
P:[20,25,27.5,30,32.5,35,37.5,40,45,50],
A:{R:[4,3,0,2,1,4,3,2,1,0], L:[1,2,0,3,4,1,2,3,4,0]},
B:{R:[0,4,0,3,2,1,4,3,2,1], L:[0,1,0,2,3,4,1,2,3,4]},
C:{R:[1,2,1,3,2,4,0,0,0,0], L:[1,2,4,3,3,4,0,0,0,0]}
};
const ZPIN = {round:'Round pin', toward:'Offset pin, number toward you', away:'Offset pin, number away'};
function zPitches(g,h,groove,pin){
const row=ZTAB[g][h]; let out=ZTAB.P.filter((p,i)=>row[i]===groove);
if(pin!=='round'){ const s=pin==='toward'?'L':'R'; const shallow=(h==='R'&&s==='L')||(h==='L'&&s==='R'); out=out.map(p=>p+(shallow?-3.5:3.5)); }
return out;
}
const degs = a => a.map(p=>p+'°').join(' or ');
const BOLTS_IN = [[.281,'1/4"'],[.343,'5/16" or 8 mm'],[.406,'3/8"'],[.421,'10 mm'],[.468,'7/16"'],[.50,'12 mm'],[.531,'1/2"'],[.578,'14 mm'],[.265,'6 mm']];
/* ============ REFERENCE PHOTOS ============ */
document.querySelectorAll('img[data-src]').forEach(i=>{ i.src = CONFIG.imgBase + i.dataset.src; });
const lb = document.getElementById('lightbox');
document.addEventListener('click',e=>{
const b=e.target.closest('.pic-btn');
if(b){ const im=b.querySelector('img'); lb.querySelector('img').src=im.src; lb.querySelector('img').alt=im.alt; lb.querySelector('p').textContent=b.parentElement.querySelector('figcaption').textContent; lb.hidden=false; return; }
if(e.target.closest('#lightbox')) lb.hidden=true;
});
document.addEventListener('keydown',e=>{ if(e.key==='Escape') lb.hidden=true; });
/* ============ STATE ============ */
const STEPS = [...document.querySelectorAll('.step')].filter(s=>s.dataset.step!=='sent');
const form = document.getElementById('wiz');
let cur = 0;
const photos = {}; // step -> [{blob,url,name,size}]
const visited = new Set([0]);
const LS = 'fanIdDraft.v1';
const $ = id => document.getElementById(id);
const val = n => { const els = form.elements[n]; if(!els) return ''; if(els instanceof RadioNodeList){ const out=[...els].filter(e=>e.checked).map(e=>e.value); return els[0] && els[0].type==='checkbox' ? out : (out[0]||''); } if(els.type==='checkbox') return els.checked?els.value:''; return els.value.trim(); };
const num = n => { const v = parseFloat(val(n)); return isFinite(v) ? v : null; };
const units = () => val('units') || 'in';
const toIn = v => v==null?null:(units()==='mm'? v/25.4 : v);
const fmt = (v,d=2) => v==null?'':(+v.toFixed(d)).toString();
const fmtLen = v => v==null ? '' : (units()==='mm' ? `${fmt(v,1)} mm` : `${fmt(v,2)}"`);
/* ============ BUILD DYNAMIC CHOICES ============ */
$('seriesChoices').innerHTML = Object.entries(SERIES).map(([k,s])=>`<label class="choice"><input type="radio" name="series" value="${k}"><span class="t">${s.name}${s.dia?` <span class="code">${s.dia[0]}–${s.dia[1]}"</span>`:''}</span><span class="d">${s.root}</span></label>`).join('');
$('matChoices').innerHTML = MATERIALS.map(([k,d,c,t])=>`<label class="choice"><input type="radio" name="material" value="${k}"><span class="t">${c?`<span class="swatch" style="background:${c}"></span>`:''}${k}</span><span class="d">${d}${t?`<br><span class="code">${t} °F</span>`:''}</span></label>`).join('');
$('bushChips').innerHTML = Object.keys(BUSHINGS).map(k=>`<button type="button" class="chip" data-bush="${k}">${k}</button>`).join('');
/* rail */
$('rail').innerHTML = STEPS.map((s,i)=>`<li><button type="button" data-go="${i}"><span class="num">${i===0?'·':i===STEPS.length-1?'✓':i}</span><span>${s.dataset.title}</span><span class="cam" data-cam="${s.dataset.step}"></span></button></li>`).join('');
/* photo boxes */
document.querySelectorAll('[data-photo]').forEach(box=>{
const key = box.dataset.photo; photos[key]=[];
box.className='photos';
box.innerHTML = `<div class="ph-head"><b>${box.dataset.photoLabel}</b><label class="btn small" for="file-${key}">Add photos</label></div>
<input type="file" id="file-${key}" accept="image/*" multiple hidden>
<div class="thumbs" id="thumbs-${key}"></div><span class="hint">Tap “Add photos” or drop images here.</span>`;
const input = box.querySelector('input');
input.addEventListener('change',()=>{ addPhotos(key,[...input.files]); input.value=''; });
box.addEventListener('dragover',e=>{e.preventDefault();box.classList.add('drag')});
box.addEventListener('dragleave',()=>box.classList.remove('drag'));
box.addEventListener('drop',e=>{e.preventDefault();box.classList.remove('drag');addPhotos(key,[...e.dataTransfer.files].filter(f=>f.type.startsWith('image/')))});
});
async function shrink(file){
try{
const url = URL.createObjectURL(file);
const img = await new Promise((res,rej)=>{const i=new Image();i.onload=()=>res(i);i.onerror=rej;i.src=url;});
const s = Math.min(1, CONFIG.maxPhotoPx/Math.max(img.naturalWidth,img.naturalHeight));
const c = document.createElement('canvas'); c.width=Math.round(img.naturalWidth*s); c.height=Math.round(img.naturalHeight*s);
c.getContext('2d').drawImage(img,0,0,c.width,c.height); URL.revokeObjectURL(url);
const blob = await new Promise(r=>c.toBlob(r,'image/jpeg',0.82));
return blob && blob.size < file.size ? blob : file;
}catch(e){ return file; }
}
async function addPhotos(key, files){
for(const f of files){
const blob = await shrink(f);
const base = (f.name||'photo').replace(/\.[^.]+$/,'');
photos[key].push({blob, url:URL.createObjectURL(blob), name:`${key}-${photos[key].length+1}-${base}.jpg`, size:blob.size});
}
drawThumbs(key); updateAll();
}
function drawThumbs(key){
$('thumbs-'+key).innerHTML = photos[key].map((p,i)=>`<div class="thumb"><img src="${p.url}" alt="Photo ${i+1}"><button type="button" aria-label="Remove photo" data-rm="${key}:${i}">×</button></div>`).join('');
}
document.addEventListener('click',e=>{
const rm = e.target.closest('[data-rm]');
if(rm){ const [k,i]=rm.dataset.rm.split(':'); URL.revokeObjectURL(photos[k][i].url); photos[k].splice(+i,1); drawThumbs(k); updateAll(); }
});
const totalBytes = () => Object.values(photos).flat().reduce((a,p)=>a+p.size,0);
const photoCount = () => Object.values(photos).flat().length;
/* ============ LIVE CALCULATIONS ============ */
function diameterIn(){
const m = val('diaMethod');
if(m==='tip') return toIn(num('diaTip'));
if(m==='radius'){ const r=toIn(num('diaRadius')); return r==null?null:r*2; }
if(m==='parts'){ const h=toIn(num('diaHub')), b=toIn(num('diaBlade')); return (h==null||b==null)?null:h+2*b; }
return null;
}
function seriesFor(d){ return Object.entries(SERIES).filter(([k,s])=>s.dia && d>=s.dia[0]-0.5 && d<=s.dia[1]+0.5).map(([k])=>k); }
function updateAll(){
// unit labels
document.querySelectorAll('.u').forEach(u=>u.textContent=units());
// show/hide
document.querySelectorAll('[data-show]').forEach(el=>{
const [k,vs]=el.dataset.show.split('='); const v=val(k); el.hidden = !vs.split('|').includes(v);
});
// ASM check
const asm = val('asm').toUpperCase().replace(/[\s-]/g,'');
$('asmCheck').textContent = !asm ? 'Copy every character, including all the zeros.' : /^ASM\d{8,}$/.test(asm) ? `Looks right: ${asm}. We'll look it up with Multiwing.` : 'ASM numbers are ASM followed by digits only. Check for a letter O typed as a zero, or send a photo.';
// diameter figure + result
const m = val('diaMethod');
$('dimTip').style.display = (!m||m==='tip')?'':'none';
$('dimRad').style.display = m==='radius'?'':'none';
$('dimParts').style.display = m==='parts'?'':'none';
$('diaCap').textContent = m==='parts' ? 'H = hub diameter, B = blade length from tip to just above the root.' : m==='radius' ? 'Measure from the tip to the exact center of the hub, then double it.' : 'Measure to the outermost point of the blade tips, straight through the center.';
const d = diameterIn();
if(d){ $('diaResult').hidden=false; $('diaOut').textContent = units()==='mm' ? `${fmt(d*25.4,0)} mm` : `${fmt(d,2)}"`;
const s = seriesFor(d); $('diaSeries').textContent = s.length ? `Fan diameter. In the range of: ${s.map(k=>SERIES[k].name).join(', ')}` : 'Fan diameter. Outside standard Multiwing ranges, please double-check.';
} else $('diaResult').hidden=true;
// blades / positions
const b=num('bladeCount'), p=num('positions');
const sn=$('spacerNote');
if(b&&p){ sn.hidden=false; if(p<b){sn.className='note caution';sn.innerHTML='<b>Check the counts.</b> Hub positions can’t be fewer than blades.';} else if(p>b){sn.className='note good';sn.textContent=`${b} blades and ${p-b} spacer${p-b>1?'s':''} in a ${p}-position hub.`;} else {sn.className='note';sn.textContent=`Full hub: every position has a blade.`;} } else sn.hidden=true;
drawHub(b,p);
// series
const ser = val('series');
const w = toIn(num('bladeWidth'));
if(w){
const pool = BLADES.filter(x=> !ser||ser==='U'||!SERIES[ser].dia ? true : x[1]===ser);
const hits = pool.filter(x=>Math.abs(x[2]-w)<=0.2).sort((a,c)=>Math.abs(a[2]-w)-Math.abs(c[2]-w));
$('widthMatches').hidden=false;
$('matchChips').innerHTML = hits.length ? hits.map(x=>`<button type="button" class="chip${val('bladeName').toUpperCase().startsWith(x[0])?' on':''}" data-blade="${x[0]}">${x[0]} · ${x[2]}"</button>`).join('') : '';
$('matchHint').textContent = hits.length ? 'Tap one to use it, then add L or R if the stamping shows it. Several blades share a width, so a root photo settles it.' : `No standard ${ser&&SERIES[ser].dia?SERIES[ser].name+' ':''}blade is ${units()==='mm'?fmt(w*25.4,0)+' mm':fmt(w,2)+'"'} wide. Re-measure just above the root, or send a photo.`;
} else $('widthMatches').hidden=true;
const bn = val('bladeName').toUpperCase().replace(/\s/g,'');
const bm = BLADES.slice().sort((a,c)=>c[0].length-a[0].length).find(x=>bn && bn.includes(x[0]));
const wf = /^[PS]\d/.test(bn);
const same = /^P[45]Z/.test(bn) ? ` Wing Fan ${bn.slice(0,4)} is the same blade as Multiwing ${bn.slice(1,4)}.` : wf ? ' This looks like a Wing Fan name. We supply Wing Fan blades and will match it.' : '';
$('stampWhere').innerHTML = bm ? `<b>${bm[0]}</b> · name location: ${bm[3]}. Width ${bm[2]}". Materials: ${bm[4]}.${same}` : (same || 'Most blade names are molded on the concave side of the blade base.');
// pitch
const S = SERIES[ser] || null;
$('pitchIntro').textContent = S && ser!=='U' ? `${S.name} directions from the Multiwing guide.` : 'Where the pitch is marked depends on the blade series.';
$('pitchHow').textContent = S ? S.pitchHow : SERIES.U.pitchHow;
$('pitchRange').textContent = S && S.pitch ? `${S.name} range: ${S.pitch}` : '';
$('insertFig').hidden = !(S && S.insert);
$('insertPhoto').hidden = !(S && S.insert);
if(S && S.insert) drawInsert(ser);
// Z pin helper
const isZ = ser==='Z';
$('zcalc').hidden = !isZ; $('zFig').hidden = !isZ;
if(isZ){
if(!val('zGroup') && bn){ const g = /6Z/.test(bn)?'C':/5Z|PMAX/.test(bn)?'B':/(^|[^0-9])(1|2|4|7)Z|TR7Z|TR8Z|EMAX/.test(bn)?'A':''; if(g) form.querySelector(`[name=zGroup][value="${g}"]`).checked=true; }
if(!val('zHand')){ const m=bn.match(/Z([LR])/); if(m) form.querySelector(`[name=zHand][value="${m[1]}"]`).checked=true; }
const g=val('zGroup'), h=val('zHand'), gr=parseInt(val('zGroove')), pin=val('zPin');
let sl=''; for(let i=1;i<=4;i++){ const x=110+(i-1)*47, on=i===gr;
sl+=`<rect x="${x-8}" y="92" width="16" height="40" rx="3" class="${on?'fa':'f'}"/>`;
if(on) sl+=`<rect x="${x-5}" y="96" width="10" height="34" rx="2" style="fill:var(--draw-accent)"/>`;
sl+=`<text class="${on?'dt':'lt'}" x="${x}" y="84" text-anchor="middle">${i}</text>`; }
$('zSlots').innerHTML=sl;
$('zFigCap').textContent = gr ? `Pin in groove ${gr}${pin&&pin!=='round'?', offset pin':''}.` : 'The four pin grooves in one blade socket.';
const zo=$('zOut');
if(g&&h&&gr&&pin){ const r=zPitches(g,h,gr,pin); zo.hidden=false;
if(r.length){ $('zOutBig').textContent=degs(r); $('zOutSub').textContent = r.length>1 ? 'Possible pitch angles. Both use this groove, so check which angle inside the blade root lines up with the pin.' : 'Pitch angle for this blade type, hand, groove and pin.';
$('zUse').innerHTML = r.map(p=>`<button type="button" class="chip${String(p)===val('pitch')?' on':''}" data-usepitch="${p}">Use ${p}°</button>`).join(''); }
else { $('zOutBig').textContent='No match'; $('zOutSub').textContent='That combination isn\'t in the Multiwing table. Check the groove number and blade type, or send a photo of the pin.'; $('zUse').innerHTML=''; }
} else { zo.hidden=true; $('zUse').innerHTML=''; }
}
// material temp
const mat = MATERIALS.find(x=>x[0]===val('material')); const t=num('opTemp');
const tn=$('tempNote');
if(mat && mat[4] && t!=null){ tn.hidden=false; const ok=t>=mat[4][0]&&t<=mat[4][1]; tn.className= ok?'note good':'note caution'; tn.innerHTML = ok?`${mat[0]} is rated ${mat[3]} °F. Your ${t} °F is inside that range.`:`<b>Outside the rating.</b> ${mat[0]} is rated ${mat[3]} °F. We'll suggest a better material.`; } else tn.hidden=true;
// bushing
const bt = val('bushType');
document.querySelectorAll('[data-bush]').forEach(c=>c.classList.toggle('on',c.dataset.bush===bt));
$('bushNote').hidden=!bt; if(bt) $('bushNote').textContent=`${bt}: ${BUSHINGS[bt]}`;
const boss=val('boss'), bs=val('bushSide');
const code = (boss==='A'||boss==='B') && bs && bs[0]!=='N' ? boss+bs[0] : '';
$('bushCode').hidden=!code; $('bushCodeOut').textContent=code;
// flange
const fo=num('flOut'), fh=num('flHole');
if(fo&&fh&&fo>fh){ $('bcResult').hidden=false; $('bcOut').textContent = units()==='mm'?`${fmt(fo-fh,1)} mm`:`${fmt(fo-fh,3)}"`; } else $('bcResult').hidden=true;
const hin = toIn(fh);
if(hin){ const best = BOLTS_IN.slice().sort((a,c)=>Math.abs(a[0]-hin)-Math.abs(c[0]-hin))[0]; $('flBolt').textContent = Math.abs(best[0]-hin)<0.03 ? `Standard clearance hole for a ${best[1]} bolt.` : ''; } else $('flBolt').textContent='';
// blades-needed balance check
const N=num('bladeCount'), K=num('bladesNeeded'), bnote=$('bladesNote');
if(N&&K){ bnote.hidden=false; const opts=[]; for(let d=2; d<N; d++) if(N%d===0) opts.push(d);
if(K>=N){ bnote.className='note good'; bnote.textContent='A full set of new blades keeps the fan in balance.'; }
else if(K>=2 && N%K===0){ bnote.className='note good'; bnote.textContent=`${K} new blades can be spaced evenly on your ${N}-blade fan, one every ${N/K} positions.`; }
else { bnote.className='note caution'; bnote.innerHTML=`<b>Check the balance.</b> ${K} new blade${K>1?'s':''} can't be spaced evenly on a ${N}-blade fan. `+(opts.length?`Replace ${opts.join(' or ')} blades, or all ${N}.`:`On a ${N}-blade fan, replacing all ${N} is the way to keep it balanced.`)+' We\'ll confirm with you before ordering.'; }
} else bnote.hidden=true;
// rail photo counts
document.querySelectorAll('[data-cam]').forEach(c=>{ const n=(photos[c.dataset.cam]||[]).length; c.textContent = n? `${n} ▣`:''; });
if(STEPS[cur].dataset.step==='contact') buildReview();
saveDraft();
}
function drawHub(b,p){
const g=$('hubDraw'); const cap=$('hubCap');
if(!p||p<1||p>20){ g.innerHTML='<circle class="fa" r="24"/>'; cap.textContent='Enter counts to preview the hub layout.'; return; }
const nb = Math.min(b||0,p); let out='';
// spread blades evenly among positions
const isBlade = Array.from({length:p},()=>false);
for(let i=0;i<nb;i++) isBlade[Math.floor(i*p/nb)]=true;
for(let i=0;i<p;i++){
const a = i/p*360;
out += isBlade[i]
? `<g transform="rotate(${a})"><path class="f" d="M28,-7 C50,-16 78,-14 86,-6 C88,4 70,10 28,7 Z"/></g>`
: `<g transform="rotate(${a})"><rect class="s" x="26" y="-5" width="12" height="10" rx="2" style="stroke:var(--draw-accent)"/></g>`;
}
g.innerHTML = out + '<circle class="fa" r="26"/><circle class="s" r="6"/>';
cap.textContent = nb<p ? `${nb} blades (drawn) and ${p-nb} spacers (small outlined squares).` : `${nb} blades in ${p} positions.`;
}
function drawInsert(ser){
const left = ser==='G' ? [15,20,25,30,35,40,45,50] : [20,25,30,35,40,45,50];
const n=left.length, x0=40, x1=320, step=(x1-x0)/(n-1), ext = ser==='G'?0:1;
let h='';
for(let i=0;i<n;i++){ const x=x0+i*step; const e=i===ext;
h+=`<line x1="${x}" y1="${e?44:56}" x2="${x}" y2="${e?92:80}" class="${e?'dim':'s'}"/>`;
h+=`<text class="lt" x="${x}" y="116" text-anchor="middle">${left[i]}</text>`;
}
$('hashes').innerHTML=h;
$('insertEx').textContent = ser==='G' ? '15° left-hand or 50° right-hand' : '25° left-hand or 45° right-hand';
}
/* chips */
form.addEventListener('click',e=>{
const c=e.target.closest('[data-blade]');
if(c){ form.elements.bladeName.value=c.dataset.blade; updateAll(); }
const up=e.target.closest('[data-usepitch]');
if(up){ form.elements.pitch.value=up.dataset.usepitch; form.elements.pitchUnknown.checked=false; updateAll(); }
const bu=e.target.closest('[data-bush]');
if(bu){ form.elements.bushType.value = form.elements.bushType.value===bu.dataset.bush?'':bu.dataset.bush; updateAll(); }
});
form.addEventListener('input',updateAll);
form.addEventListener('change',updateAll);
form.addEventListener('submit',e=>e.preventDefault());
/* ============ NAVIGATION ============ */
function go(i){
i=Math.max(0,Math.min(STEPS.length-1,i)); cur=i; visited.add(i);
STEPS.forEach((s,k)=>s.hidden=k!==i); $('sentStep').hidden=true; $('navrow').hidden=false;
document.querySelectorAll('#rail button').forEach((b,k)=>{ b.parentElement.className = k===i?'cur':(visited.has(k)&&k<i?'done':''); b.className=b.parentElement.className; b.setAttribute('aria-current',k===i?'step':'false'); });
$('back').disabled = i===0;
const last = i===STEPS.length-1;
$('next').textContent = last ? (CONFIG.endpoint?'Send to us':'Send (preview)') : i===0 ? 'Start →' : 'Next →';
$('skipTxt').textContent = last ? `${photoCount()} photo${photoCount()===1?'':'s'} attached` : 'Blank fields are fine';
$('mStep').textContent = `Step ${i+1} of ${STEPS.length}`; $('mName').textContent = STEPS[i].dataset.title.replace('&amp;','&'); $('mTrack').style.width = `${(i)/(STEPS.length-1)*100}%`;
updateAll();
const top = document.querySelector('.stage').getBoundingClientRect().top + window.scrollY - 100;
if(window.scrollY > top) window.scrollTo({top, behavior:'smooth'});
}
document.querySelector('.step[data-step="sent"]').id='sentStep';
$('rail').addEventListener('click',e=>{const b=e.target.closest('[data-go]'); if(b) go(+b.dataset.go);});
$('back').addEventListener('click',()=>go(cur-1));
$('next').addEventListener('click',()=> cur===STEPS.length-1 ? send() : go(cur+1));
document.addEventListener('click',e=>{const ed=e.target.closest('[data-edit]'); if(ed) go(+ed.dataset.edit);});
/* ============ SUMMARY ============ */
function sections(){
const d=diameterIn(); const ser=val('series'); const L=v=>v==null?'':fmtLen(v);
const mount=val('mount'); const need=val('need');
const bush = val('bushType');
return [
['Before you start',0,[['Units',units()],['Fan removed',val('fanRemoved')],['ID tag',val('tagType')],['ASM number',val('tagType')==='Multiwing ASM number'?val('asm').toUpperCase().replace(/\s/g,''):''],['Tag code',/Wing Fan|Other/.test(val('tagType'))?val('tagCode'):''],['Equipment / invoice',val('knownPart')]]],
['Diameter',1,[['Method',{tip:'Tip to tip',radius:'Tip to center × 2',parts:'Hub + 2 blades'}[val('diaMethod')]||''],['Measured', val('diaMethod')==='parts'? (num('diaHub')&&num('diaBlade')?`hub ${L(num('diaHub'))}, blade ${L(num('diaBlade'))}`:'') : L(num(val('diaMethod')==='tip'?'diaTip':'diaRadius'))],['Fan diameter', d? `${fmt(d,2)}" (${fmt(d*25.4,0)} mm)`:'']]],
['Blades & positions',2,[['Blades',val('bladeCount')],['Hub positions',val('positions')],['Hub outside dia',L(num('hubOD'))],['Spacers', (num('positions')&&num('bladeCount')&&num('positions')>=num('bladeCount'))? String(num('positions')-num('bladeCount')):''],['All blades same',val('bladesMatch')]]],
['Blade series',3,[['Series',ser?SERIES[ser].name:''],['Brand',val('brand')],['Blade width',L(num('bladeWidth'))],['Blade name',val('bladeName').toUpperCase()]]],
['Pitch & rotation',4,[['Pitch', val('pitchUnknown')?'Could not read':(val('pitch')?val('pitch')+'°':'')],['Pin groove', val('series')==='Z'&&val('zGroove')?val('zGroove'):''],['Pin type', val('series')==='Z'&&val('zPin')?ZPIN[val('zPin')]:''],['Pitch from pin', (val('series')==='Z'&&val('zGroup')&&val('zHand')&&val('zGroove')&&val('zPin'))?(degs(zPitches(val('zGroup'),val('zHand'),parseInt(val('zGroove')),val('zPin')))||'no match'):''],['Rotation', [val('rotation'),val('rotationView')&&('viewed from '+val('rotationView').toLowerCase())].filter(Boolean).join(', ')]]],
['Material',5,[['Material',val('material')],['Max air temp',val('opTemp')?val('opTemp')+' °F':'']]],
['Mounting',6,[['Type',mount],['Boss side', val('boss')?({A:'A · air intake',B:'B · air discharge','?':'Not sure'}[val('boss')]):''],
...(mount==='Straight bore & keyway'?[['Shaft',L(num('sbShaft'))],['Keyway',L(num('sbKey'))],['Set screws',val('sbScrews')]]:[]),
...(mount==='Taper-lock bushing'?[['Bushing',bush],['Center boss bolts',val('bossBolts')],['Bore marked',val('bushBore')],['Shaft measured',L(num('bushShaft'))],['Keyway',L(num('bushKey'))],['Position',val('bushSide')],['Position code',$('bushCode').hidden?'':$('bushCodeOut').textContent]]:[]),
...(mount==='Flange mount'?[['Pilot hole',L(num('flPilot'))],['Bolt holes',val('flHoles')],['Hole diameter',L(num('flHole'))],['Bolt circle',$('bcResult').hidden?'':$('bcOut').textContent],['Bolts to',val('flEngine')]]:[])]],
['Equipment & request',7,[['Needs',need.join(', ')],['Blades needed',val('bladesNeeded')],['Equipment',val('equip')],['Air direction',val('airDir')],['RPM',val('rpm')],['HP',val('hp')],['Quantity',val('qty')],['Condition',val('condition')],['Urgency',val('urgency')],['Notes',val('notes')]]],
['Contact',8,[['Name',val('cName')],['Company',val('cCompany')],['Email',val('cEmail')],['Phone',val('cPhone')],['Location',val('cLoc')],['Preferred contact',val('cPref')],['Found us via',val('cSource')]]]
];
}
function specLine(){
const d=diameterIn(); const ser=val('series'); const parts=[];
if(val('tagType')==='Multiwing ASM number'&&val('asm')) parts.push(val('asm').toUpperCase().replace(/\s/g,''));
else if(/Wing Fan|Other/.test(val('tagType'))&&val('tagCode')) parts.push('tag '+val('tagCode'));
parts.push(d?`${fmt(d,1)}" dia`:'dia ?');
const b=val('bladeCount'), p=val('positions'); parts.push(b||p?`${b||'?'} blades / ${p||'?'} positions`:'blades ?');
parts.push(val('bladeName')?val('bladeName').toUpperCase():(ser&&ser!=='U'?SERIES[ser].name:'series ?'));
if(val('brand')&&val('brand')!=='Not sure') parts.push(val('brand'));
parts.push(val('pitchUnknown')?'pitch ?':(val('pitch')?val('pitch')+'°':'pitch ?'));
parts.push(val('material')||'material ?');
const m=val('mount');
if(m==='Taper-lock bushing') parts.push(`${val('bushType')||'?'} bushing ${val('bushBore')||fmtLen(num('bushShaft'))||''} ${$('bushCode').hidden?'':$('bushCodeOut').textContent}`.replace(/\s+/g,' ').trim());
else if(m==='Straight bore & keyway') parts.push(`straight bore ${fmtLen(num('sbShaft'))||'?'}`);
else if(m==='Flange mount') parts.push(`flange ${val('flHoles')||'?'} holes${$('bcResult').hidden?'':' on '+$('bcOut').textContent+' BC'}`);
else parts.push(m||'mount ?');
return parts.join('  ·  ');
}
const esc = s => String(s).replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
function buildReview(){
$('specLine').textContent = specLine();
$('review').innerHTML = sections().map(([t,i,rows])=>{
const shown = rows.filter(r=>r[1]); const pc = (photos[STEPS[i].dataset.step]||[]).length;
return `<div class="rv"><div class="rv-h"><b>${t}</b><button type="button" class="btn small" data-edit="${i}">Edit</button></div><dl>${shown.length?shown.map(r=>`<dt>${esc(r[0])}</dt><dd>${esc(r[1])}</dd>`).join(''):'<dt>—</dt><dd class="miss">Left blank</dd>'}${pc?`<dt>Photos</dt><dd>${pc}</dd>`:''}</dl></div>`;
}).join('');
const mb = totalBytes()/1048576;
$('meterTxt').textContent = `${photoCount()} photos · ${mb.toFixed(1)} of ${CONFIG.maxTotalMB} MB`;
$('shopLinks').innerHTML = shopLinks();
$('meterBar').style.width = Math.min(100, mb/CONFIG.maxTotalMB*100)+'%';
$('meter').classList.toggle('over', mb>CONFIG.maxTotalMB);
}
function shopLinks(){
const n = val('need').join(' '); const u = CONFIG.storeUrl.replace(/\/$/,'')+'/collections/';
const L = [];
if(/blades|Cutting/i.test(n)) L.push(['Fan blades','multiwing-wingfan-blades']);
if(/Complete fan/.test(n)) L.push(['Complete fans','multiwing-wingfan-fans']);
if(/Hub|boss|Pitch/.test(n)) L.push(['Hubs, bosses and hardware','multiwing-wingfan-hubs']);
L.push(['All Multiwing and Wing Fan parts','propellers-and-fans']);
return 'Some of these parts are listed in our store: ' + L.map(([t,h])=>`<a href="${u+h}">${t}</a>`).join(' · ') + '. Many more are made by Multiwing and Wing Fan than we list, so if yours isn\'t there we can special-order it. We confirm the exact parts and trim length before you order.';
}
function plainText(){
return 'FAN SPEC: '+specLine()+'\n\n'+sections().map(([t,,rows])=>{const s=rows.filter(r=>r[1]); return s.length? `${t.toUpperCase()}\n`+s.map(r=>`  ${r[0]}: ${r[1]}`).join('\n'):''}).filter(Boolean).join('\n\n')+`\n\nPHOTOS: ${photoCount()}`;
}
/* ============ SEND ============ */
function send(){
const errs=[];
if(!val('cName')) errs.push('Add your name.');
const em=val('cEmail'); if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em)) errs.push('Add a valid email address so we can reply.');
if(totalBytes()/1048576 > CONFIG.maxTotalMB) errs.push(`Photos total more than ${CONFIG.maxTotalMB} MB. Remove a few, or send the extras by email after.`);
$('errors').textContent = errs.join(' ');
if(errs.length) return;
const text = plainText();
if(!CONFIG.endpoint){ showSent(text,true); return; }
const f = $('sendForm'); f.innerHTML=''; f.action = CONFIG.endpoint;
const add=(n,v)=>{const i=document.createElement('input');i.type='hidden';i.name=n;i.value=v;f.appendChild(i);};
add('_subject', `${CONFIG.subject}: ${val('cName')}${val('cCompany')?' ('+val('cCompany')+')':''}`);
add('_template','table'); add('_captcha','false');
if(CONFIG.thankYouUrl) add('_next', CONFIG.thankYouUrl);
add('name', val('cName')); add('email', em);
add('Fan spec', specLine());
sections().forEach(([t,,rows])=>rows.forEach(r=>{ if(r[1] && !['Name','Email'].includes(r[0])) add(`${t} · ${r[0]}`, r[1]); }));
add('Full summary', text);
const all = Object.values(photos).flat();
if(all.length){
try{
all.forEach((p,k)=>{
const dt = new DataTransfer();
dt.items.add(new File([p.blob], p.name, {type:p.blob.type||'image/jpeg'}));
const fi=document.createElement('input'); fi.type='file'; fi.name=`Photo ${k+1} (${p.name.split('-')[0]})`; fi.files=dt.files; f.appendChild(fi);
});
}catch(e){ add('Photos note', `${all.length} photos could not be attached by this browser. Please reply to this email with them.`); }
}
try{ localStorage.removeItem(LS); }catch(e){}
$('next').disabled=true; $('next').textContent='Sending…';
f.submit();
}
function showSent(text,demo){
STEPS.forEach(s=>s.hidden=true); $('sentStep').hidden=false; $('navrow').hidden=true;
$('demoFlag').hidden=!demo;
$('sentTitle').textContent = demo?'This is what we would receive':'Request sent';
$('sentBody').textContent = demo ? `Preview mode: nothing was sent. When the form is connected, this summary and ${photoCount()} photo${photoCount()===1?'':'s'} arrive by email, with the customer's address set as reply-to.` : 'Thanks. We have your fan details and photos and will reply shortly.';
$('sentSpec').textContent = text;
$('sentLinks').innerHTML = shopLinks();
}
$('copySpec').addEventListener('click',async()=>{
const t=$('sentSpec').textContent;
try{ await navigator.clipboard.writeText(t); $('copySpec').textContent='Copied'; }
catch(e){ const ta=$('copyFallback'); ta.hidden=false; ta.value=t; ta.select(); $('copySpec').textContent='Select and copy the text below'; }
});
$('startOver').addEventListener('click',()=>{
form.reset(); Object.keys(photos).forEach(k=>{photos[k].forEach(p=>URL.revokeObjectURL(p.url)); photos[k]=[]; drawThumbs(k);});
try{ localStorage.removeItem(LS); }catch(e){}
visited.clear(); go(0);
});
/* ============ DRAFT (this device only) ============ */
function saveDraft(){
try{
const data={};
[...form.elements].forEach(el=>{ if(!el.name||el.type==='file') return;
if(el.type==='radio'||el.type==='checkbox'){ if(el.checked){ (data[el.name] ||= []).push(el.value); } }
else data[el.name]=el.value; });
localStorage.setItem(LS, JSON.stringify(data));
}catch(e){}
}
function loadDraft(){
try{
const data=JSON.parse(localStorage.getItem(LS)||'null'); if(!data) return false;
[...form.elements].forEach(el=>{ if(!el.name||el.type==='file'||!(el.name in data)) return;
if(el.type==='radio'||el.type==='checkbox') el.checked = [].concat(data[el.name]).includes(el.value);
else el.value=data[el.name]; });
return true;
}catch(e){ return false; }
}
if(/[?&]sent=1/.test(location.search)){
try{ localStorage.removeItem(LS); }catch(e){}
go(0); showSent('',false);
$('sentSpec').hidden=true; $('copySpec').hidden=true;
$('sentBody').textContent='Thanks. We have your fan details and photos and will reply by email or phone, usually within one business day.';
}else{
if(loadDraft()) $('saveNote').textContent='Picked up where you left off. Photos need re-adding.';
go(0);
}
})();
